function Footer() {
    return (
      <footer className="footer">
        <div className="footer-grid">
          <div>
            <h3>Himas Hotel & Bake House</h3>
            <p>Fresh bakery items, breakfast, tea, and short eats in Palamunai.</p>
          </div>
  
          <div>
            <h4>Contact</h4>
            <p>Phone: 0672255339</p>
            <p>WhatsApp: 0757181903</p>
          </div>
  
          <div>
            <h4>Location</h4>
            <p>96A Main Street, Palamunai-3</p>
            <p>Open Daily: 3.30 AM - 10.00 PM</p>
          </div>
        </div>
  
        <p className="footer-copy">
          © 2026 Himas Hotel & Bake House. All rights reserved.
        </p>
      </footer>
    );
  }
  
  export default Footer;